<script>
export default {
    props: {
        message: {
            type: String,
            default: 'Loading Data'
        },
        subtitle: {
            type: String,
            default: 'Just a moment…'
        }
    }
}
</script>

<template>
    <div class="flex h-full items-center justify-center">
        <div class="flex animate-pulse flex-col items-center justify-center space-y-0.5">
            <span class="lnr icon-hourglass !text-4xl !text-blue-500 mb-2 inline-block w-8 text-center"></span>
            <span class="text-base font-medium">{{ message }}</span>
            <span class="text-sm text-gray-500">{{ subtitle }}</span>
        </div>
    </div>
</template>